import { render, staticRenderFns } from "./TabelaResultadosOcorrencias.vue?vue&type=template&id=fa4e9b92&scoped=true&"
import script from "./TabelaResultadosOcorrencias.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosOcorrencias.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosOcorrencias.vue?vue&type=style&index=0&id=fa4e9b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4e9b92",
  null
  
)

export default component.exports